import { render, staticRenderFns } from "./drugmaster.vue?vue&type=template&id=1e95c27c&"
import script from "./drugmaster.vue?vue&type=script&lang=js&"
export * from "./drugmaster.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports